import Swiper from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { Navigation, Pagination } from 'swiper/modules';

class StepsList {
    constructor() {
        this.section = document.querySelector('.component-block-steps-list');
        this.slider = this.section.querySelector('.swiper--component-block-steps-list');
        this.navigationPrev = document.querySelector('.slider-button-prev--component-block-steps-list');
        this.navigationNext = document.querySelector('.slider-button-next--component-block-steps-list');
        this.navigationPrevMobile = document.querySelector('.slider-button-prev--component-block-steps-list-mobile');
        this.navigationNextMobile = document.querySelector('.slider-button-next--component-block-steps-list-mobile');
        this.pagination = this.section.querySelector('.swiper-pagination-nav--component-block-steps-list-mobile');

        this.ready();
    }

    ready() {
        const swiper = new Swiper(this.slider, {
            modules: [Navigation, Pagination],
            grabCursor: true,
            slidesPerView: 2,
            spaceBetween: 30,
            allowTouchMove: true,
            breakpoints: {
                0: {
                    slidesPerView: 1,
                    pagination: {
                        el: this.pagination,
                        type: 'fraction',
                    },
                    navigation: {
                        nextEl: this.navigationNextMobile,
                        prevEl: this.navigationPrevMobile,
                    },
                },
                1024: {
                    slidesPerView: 2.6,
                    pagination: '',
                    slidesOffsetBefore: 0,
                    slidesOffsetAfter: 60,
                    navigation: {
                        nextEl: this.navigationNext,
                        prevEl: this.navigationPrev,
                    },
                },
            },
        });
    }
}

class ResumeForm {
    constructor() {
        this.form = document.querySelector('#resumeForm');
        this.input = this.form.querySelector('#resumeInput');
        this.button = this.form.querySelector('#resumeButton');

        this.fieldFile = this.form.querySelector('#resumeInput');
        this.fieldFile.addEventListener('click', () => {
            window.loadRecaptchaV3();
        });

        this.ready();
    }

    ready() {
        this.form.addEventListener('submit', (e) => {
            e.preventDefault();
            const button = this.form.querySelector('#resumeButton');
            const errorMessage = this.form.querySelector('.resumeError');
            const fileErrorMessage = this.form.querySelector('.resumeFileError');
            const successMessage = this.form.querySelector('.resumeSuccess');

            button.setAttribute('disabled', true);

            const file = this.input.files[0];

            if (!file) {
                errorMessage.classList.remove('hidden');
                fileErrorMessage.classList.add('hidden');
                successMessage.classList.add('hidden');
            } else if (file?.type !== 'application/pdf' || file?.size > 5 * 1024 * 1024) {
                errorMessage.classList.add('hidden');
                fileErrorMessage.classList.remove('hidden');
                successMessage.classList.add('hidden');
            } else {
                $.ajax({
                    type: 'POST',
                    url: $(this.form).data('action'),
                    data: new FormData(this.form),
                    processData: false,
                    contentType: false,
                    success: function (data) {
                        button.disabled = false;

                        errorMessage.classList.add('hidden');
                        fileErrorMessage.classList.add('hidden');
                        successMessage.classList.remove('hidden');
                        return;
                    },
                    error: function (data) {
                        button.disabled = false;

                        errorMessage.classList.remove('hidden');
                        fileErrorMessage.classList.add('hidden');
                        successMessage.classList.add('hidden');
                    },
                    finally: function () {
                        button.disabled = false;
                    },
                });
            }
            button.removeAttribute('disabled');
        });
    }
}

export default { StepsList, ResumeForm };

if (document.querySelector('.component-block-steps-list')) {
    new StepsList();
}
if (document.querySelector('#resumeForm')) {
    new ResumeForm();
}
